import cuid from 'cuid';
import PropTypes from 'prop-types';
import React from 'react';

import { Box, Button, DataGrid } from 'components/AORedesign';

const renderCell = (params, setSelectedClaim) => {
  const handleOnClick = () => {
    const { policyNumber, occurrenceNumber } = params.row;
    setSelectedClaim({ policyNumber, occurrenceNumber });
  };

  return (
    params.row && (
      <Button variant="text" aria-label="claims-inquiry-details" color="primary" onClick={handleOnClick}>
        {params.value}
      </Button>
    )
  );
};

const getDataGridColumns = (searchByType, setSelectedClaim) => [
  {
    field: 'name',
    headerName: `${searchByType === 'policyNumber' || searchByType === 'insuredName' ? 'Insured Name' : 'Claimant Name'}`,
    sortable: true,
    width: 400,
    renderCell: (params) => renderCell(params, setSelectedClaim),
  },
  {
    field: 'policyNumber',
    headerName: 'Policy Number',
    sortable: true,
    width: 200,
  },
  {
    field: 'dateOfLoss',
    headerName: `${searchByType === 'openClaims' ? 'Date Reported' : 'Date of Loss'}`,
    sortable: true,
    width: 200,
    type: 'date',
  },
  {
    field: 'occurrenceNumber',
    headerName: 'Occurrence Number',
    sortable: true,
    width: 200,
  },
];

const ClaimsDataGrid = (props) => {
  const { results, setSelectedClaim, loadingSearchResults, searchByType, handleOnPageChange, ...otherProps } = props;
  return (
    <Box mt={2}>
      <DataGrid
        pageSize={50}
        rowsPerPageOptions={[50]}
        paginationMode="server"
        noResultsMessage="[No claims on file.]"
        exportToCSV
        rows={results?.results?.map((row) => ({ ...row, id: cuid() }))}
        columns={getDataGridColumns(searchByType, setSelectedClaim)}
        rowCount={results?.totalCount}
        loading={loadingSearchResults}
        onPageChange={handleOnPageChange}
        {...otherProps}
      />
    </Box>
  );
};

ClaimsDataGrid.propTypes = {
  results: PropTypes.object,
  setSelectedClaim: PropTypes.func,
  loadingSearchResults: PropTypes.bool,
  handleOnPageChange: PropTypes.func,
  searchByType: PropTypes.string,
};

export default ClaimsDataGrid;
